import { Props } from "./BarChart";

export default (props: Props, setImage: React.Dispatch<React.SetStateAction<string>>): Chart.ChartConfiguration => ({
    type: "horizontalBar",
    data: {
        labels: [],
        datasets: [
            {
                backgroundColor: "#03274a",
                borderColor: "#ff0000",
                data: []
            }
        ]
    },
    options: {
        tooltips: {
            callbacks: {
                label: (tooltipItem) => {
                    return tooltipItem.value ? parseFloat(tooltipItem.value).toLocaleString() : '';
                }
            }
        },
        legend: {
            display: false
        },
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.5,
        scales: {
            yAxes: [
                {
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        beginAtZero: true
                    },
                    scaleLabel: {
                        display: props.yLabel !== undefined,
                        labelString: props.yLabel,
                        fontColor: "#000",
                        padding: isSmallWidth() ? 5 : 30,
                        fontSize: isSmallWidth() ? 11 : 14
                    }
                }
            ],
            xAxes: [
                {
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        beginAtZero: false,
                        callback: (value) => value.toLocaleString()
                    },
                    scaleLabel: {
                        display: props.xLabel !== undefined,
                        labelString: props.xLabel,
                        fontColor: "#000",
                        fontSize: isSmallWidth() ? 11 : 14,
                        padding: isSmallWidth() ? 5 : 30
                    }
                }
            ]
        },
        title: {
            display: false,
            fontSize: 18
        },
        animation: {
            onComplete: function() {
                setImage((this as unknown as Chart).toBase64Image());
            }
        }
    }
});

function isSmallWidth() {
    return window.innerWidth < 600;
}
